<template>
  <section v-if="perfectDay">
    <div>
      <h2 class="info-heading" id="perfect-day-title">{{ perfectDay.title }}</h2>
      <div class="plan-body">
        <div class="plan-header">
          <img
            class="lazyload"
            :data-src="perfectDay.picture"
            alt="image"
            loading="lazy"
          />
          <span class="summary" v-html="getSummary"></span>
        </div>

        <div v-if="expanded">
          <div class="plan-content" v-html="getPlan"></div>
        </div>

        <div v-else>
          <div v-if="togglePlan">
            <span class="plan-content" v-html="getPlan"></span>
          </div>
          <button
            v-b-toggle="'collapse3'"
            class="show-info btn-anim trans-gold"
            @click="togglePlan = !togglePlan"
          >
            Read {{ togglePlan ? "Less" : "More" }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "TourPlan",
  props: {
    expanded: {
      type: Boolean,
      default: false
    },
    perfectDay: {
      type: Object,
      default: false
    }
  },
  computed: {
    getSummary() {
      return this.perfectDay.description?.split("\n")[0];
    },
    getPlan() {
      return this.perfectDay.description?.split("\n")
        .slice(1)
        .join("\n")
        .replace(
          /<h2\b[^>]*>(.*?)<\/h2>/g,
          "<h3 style='margin-top: 32px'>$1</h3>"
        );
    }
  },
  data() {
    return {
      togglePlan: false
    };
  },
  // when click read less, the page will scroll up to the section title
  watch: {
    togglePlan(newVal) {
      if (!newVal) {
        this.$nextTick(() => {
          const element = document.getElementById("perfect-day-title");
          if (element) {
            const yOffset = -80; // Adjust the offset if needed
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: "smooth" });
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.plan-body {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 16px;
  background-color: #f7f7f7;
  border-radius: 16px;
}

#perfect-day-title {
  scroll-behavior: smooth;
}

.plan-header {
  display: grid;
  grid-template-columns: 240px 1fr;
  gap: 16px;
  align-items: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    aspect-ratio: 4/3;
  }

  a {
    color: $woi-gold-light;
  }

  .plan-content h2 {
    color: $blackberry !important;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.summary {
  margin: 0;
  p {
    margin: 0;
  }
}

.plan-content {
  margin-top: 16px;
}

.plan-content h3 {
  margin-bottom: 8px;
}
</style>
